import React from 'react';
import ChevronRightRoundedIcon from '@material-ui/icons/ChevronRightRounded';
import { useHistory } from 'react-router-dom';
import Routes from 'consts/routes';
import Router from 'components/Router/Router';

const { useRouteMatch, useParams } = Router;

const CaseSubHeader = ({ classes }: any) => {
  const history = useHistory();
  const route = useRouteMatch();
  const { provider } = useParams() as any;

  const providerName = provider ? localStorage.getItem('providerName') : '';

  const innerRoutes = [
    {
      route: Routes.MPS_HUB.PROVIDER_EDIT,
      text: 'Edit',
      backRoute: Routes.MPS_HUB.PROVIDER.replace(':provider', provider)
    }
  ];

  const currentInnerRoute = route
    ? innerRoutes.find(innerRoute => innerRoute.route === route.path)
    : null;

  return (
    <>
      <span
        className={classes.link}
        onClick={() => history.push(Routes.MPS_HUB.BASE)}
      >
        MPS Hub
      </span>
      <ChevronRightRoundedIcon fontSize="small" />
      <span
        className={currentInnerRoute ? classes.link : ''}
        style={{ textTransform: 'capitalize' }}
        onClick={() =>
          currentInnerRoute && history.push(currentInnerRoute.backRoute)
        }
      >
        {providerName}
      </span>
      {currentInnerRoute && (
        <>
          <ChevronRightRoundedIcon fontSize="small" />
          <span>{currentInnerRoute.text}</span>
        </>
      )}
    </>
  );
};

export default CaseSubHeader;
